
import { motion } from "framer-motion";
import Container from "../../components/ui/container";
import { Card, CardContent } from "../../components/ui/card";
import { Avatar, AvatarFallback } from "../../components/ui/avatar";
import { Quote } from "lucide-react";

const testimonials = [
  {
    quote: "We reduced our development costs by 70% while maintaining exceptional quality of work across all our projects.",
    author: "David Johnson",
    role: "CTO, Bing",
    initials: "SJ",
    image: "https://randomuser.me/api/portraits/men/1.jpg"
  },
  {
    quote: "The talent on this platform is exceptional. Our hiring process became significantly more efficient and productive.",
    author: "Michael Chen",
    role: "Engineering Director, Freshcut",
    initials: "MC",
    image: "https://randomuser.me/api/portraits/men/2.jpg"
  },
  {
    quote: "Outstanding support and communication throughout our projects. The developers integrated seamlessly with our team.",
    author: "Emma Davis",
    role: "Product Manager, PartnerStack",
    initials: "ED",
    image: "https://randomuser.me/api/portraits/women/3.jpg"
  }
];

export default function Testimonials() {
  return (
    <section className="py-20 bg-gray-50">
      <Container>
        <div className="text-center max-w-2xl mx-auto mb-12">
          <motion.h2 
            className="text-3xl font-bold"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
          >
            What Our Clients Say
          </motion.h2>
          <motion.p 
            className="mt-4 text-muted-foreground"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.1 }}
            viewport={{ once: true }}
          >
            Hear from businesses that have transformed their operations with our talent
          </motion.p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="h-full"
            >
              <Card className="h-full">
                <CardContent className="pt-6 flex flex-col h-full">
                  <p className="text-lg mb-6 flex-grow">{testimonial.quote}</p>
                  <div className="flex items-center mt-auto">
                    <Avatar className="h-10 w-10">
                      <img 
                        src={testimonial.image} 
                        alt={testimonial.author} 
                        className="w-full h-full object-cover rounded-full"
                      />
                      <AvatarFallback>{testimonial.initials}</AvatarFallback>
                    </Avatar>
                    <div className="ml-4">
                      <p className="font-semibold">{testimonial.author}</p>
                      <p className="text-sm text-muted-foreground">{testimonial.role}</p>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </motion.div>
          ))}
        </div>
      </Container>
    </section>
  );
}
